
import {EventDispatcher} from "../EventDispatcher.js";

export class CurbRevealWindow extends EventDispatcher {

	constructor(viewer) {
		super();

		this.viewer = viewer;
		this.elRoot = $("#curb_reveal_window");
		this.currentReveal = null;

		// Close button
		let closeBtn = $("#closeCurbRevealWindow");
		closeBtn.attr("src", `${Potree.resourcePath}/icons/close.svg`);
		closeBtn.click(() => {
			this.hide();
		});
	}

	show(curbReveal) {
		this.currentReveal = curbReveal;
		this.elRoot.fadeIn();
		this.drawChart(curbReveal);
	}

	hide() {
		this.elRoot.fadeOut();
		this.currentReveal = null;
	}

	drawChart(curbReveal) {
		let svg = d3.select("#curb_reveal_svg");
		svg.selectAll("*").remove();

		let smoothed = curbReveal.profileSmoothed || [];
		let raw = curbReveal.profilePoints || [];
		let edge = curbReveal.detectedEdge;

		if (smoothed.length === 0) { return; }

		let container = document.getElementById("curb_reveal_svg");
		let rect = container.getBoundingClientRect();
		let totalWidth = rect.width;
		let totalHeight = rect.height;

		let margin = {top: 20, right: 30, bottom: 40, left: 60};
		let width = totalWidth - margin.left - margin.right;
		let height = totalHeight - margin.top - margin.bottom;

		let feetPerMeter = 3.28084;

		let g = svg.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		// X scale: distance along transect in feet
		let xExtent = d3.extent(smoothed, d => d.distanceAlong * feetPerMeter);
		let xScale = d3.scale.linear()
			.domain(xExtent)
			.range([0, width]);

		// Y scale: elevation in feet
		let allElevs = raw.map(d => d.elevation * feetPerMeter)
			.concat(smoothed.map(d => d.elevation * feetPerMeter));
		let yExtent = [d3.min(allElevs), d3.max(allElevs)];
		let yPadding = (yExtent[1] - yExtent[0]) * 0.15 || 0.5;
		let yScale = d3.scale.linear()
			.domain([yExtent[0] - yPadding, yExtent[1] + yPadding])
			.range([height, 0]);

		// X axis
		let xAxis = d3.svg.axis().scale(xScale).orient("bottom").ticks(8);
		g.append("g")
			.attr("transform", "translate(0," + height + ")")
			.call(xAxis)
			.selectAll("text, line, path")
			.style("fill", "#9d9d9d")
			.style("stroke", "#9d9d9d");

		// X axis label
		g.append("text")
			.attr("x", width / 2)
			.attr("y", height + 35)
			.attr("text-anchor", "middle")
			.style("fill", "#9d9d9d")
			.style("font-size", "12px")
			.text("Distance (ft)");

		// Y axis
		let yAxis = d3.svg.axis().scale(yScale).orient("left").ticks(6);
		g.append("g")
			.call(yAxis)
			.selectAll("text, line, path")
			.style("fill", "#9d9d9d")
			.style("stroke", "#9d9d9d");

		// Y axis label
		g.append("text")
			.attr("transform", "rotate(-90)")
			.attr("y", -45)
			.attr("x", -height / 2)
			.attr("text-anchor", "middle")
			.style("fill", "#9d9d9d")
			.style("font-size", "12px")
			.text("Elevation (ft)");

		// Raw binned points (small, semi-transparent)
		g.selectAll(".raw-point")
			.data(raw)
			.enter()
			.append("circle")
			.attr("cx", d => xScale(d.distanceAlong * feetPerMeter))
			.attr("cy", d => yScale(d.elevation * feetPerMeter))
			.attr("r", 2)
			.attr("fill", "rgba(0, 204, 102, 0.25)");

		// Smoothed profile line (green)
		let line = d3.svg.line()
			.x(d => xScale(d.distanceAlong * feetPerMeter))
			.y(d => yScale(d.elevation * feetPerMeter));

		g.append("path")
			.datum(smoothed)
			.attr("d", line)
			.attr("fill", "none")
			.attr("stroke", "#00cc66")
			.attr("stroke-width", 2.5);

		// Edge annotations (if edge detected)
		if (edge) {
			let edgeX = xScale(edge.edgeDistanceAlong * feetPerMeter);
			let curbY = yScale(edge.curbElev * feetPerMeter);
			let roadY = yScale(edge.roadElev * feetPerMeter);

			// Vertical dashed line at detected edge
			g.append("line")
				.attr("x1", edgeX).attr("x2", edgeX)
				.attr("y1", 0).attr("y2", height)
				.attr("stroke", "#ffff00")
				.attr("stroke-width", 1.5)
				.attr("stroke-dasharray", "6,4")
				.attr("opacity", 0.7);

			// Horizontal dashed line at curb elevation
			g.append("line")
				.attr("x1", 0).attr("x2", width)
				.attr("y1", curbY).attr("y2", curbY)
				.attr("stroke", "#cc0000")
				.attr("stroke-width", 1)
				.attr("stroke-dasharray", "4,4")
				.attr("opacity", 0.6);

			// Horizontal dashed line at road elevation
			g.append("line")
				.attr("x1", 0).attr("x2", width)
				.attr("y1", roadY).attr("y2", roadY)
				.attr("stroke", "#0066cc")
				.attr("stroke-width", 1)
				.attr("stroke-dasharray", "4,4")
				.attr("opacity", 0.6);

			// Shaded region between curb and road elevations at the edge
			let shadeWidth = 20;
			g.append("rect")
				.attr("x", edgeX - shadeWidth / 2)
				.attr("y", curbY)
				.attr("width", shadeWidth)
				.attr("height", roadY - curbY)
				.attr("fill", "rgba(255, 204, 0, 0.2)")
				.attr("stroke", "rgba(255, 204, 0, 0.5)")
				.attr("stroke-width", 1);

			// Reveal annotation
			let revealInches = edge.revealMeters * 39.3701;
			let annotationY = (curbY + roadY) / 2;

			g.append("text")
				.attr("x", edgeX + 15)
				.attr("y", annotationY)
				.attr("text-anchor", "start")
				.attr("dominant-baseline", "middle")
				.style("fill", "#ffcc00")
				.style("font-size", "13px")
				.style("font-weight", "bold")
				.text(revealInches.toFixed(1) + " in");

			// Curb label
			g.append("text")
				.attr("x", width - 5)
				.attr("y", curbY - 5)
				.attr("text-anchor", "end")
				.style("fill", "#cc0000")
				.style("font-size", "11px")
				.text("Curb: " + (edge.curbElev * feetPerMeter).toFixed(2) + " ft");

			// Road label
			g.append("text")
				.attr("x", width - 5)
				.attr("y", roadY + 14)
				.attr("text-anchor", "end")
				.style("fill", "#0066cc")
				.style("font-size", "11px")
				.text("Road: " + (edge.roadElev * feetPerMeter).toFixed(2) + " ft");
		}
	}
}
